// assets/predictive-search-v2.js
// Predictive Search v2 — historique au focus + suggestions + PRODUITS en direct + empty-state quand input focus & vide

const STORAGE_KEY = 'ps_recent_searches';
const MAX_RECENT = 8;
const DEBOUNCE_MS = 200;

const debounce = (fn, ms = DEBOUNCE_MS) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
const getRecent = () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; } };
const saveRecent = (q) => {
  const s = (q || '').trim(); if (!s) return;
  const list = getRecent().filter(v => v.toLowerCase() !== s.toLowerCase());
  list.unshift(s); localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
};
const currencyISO = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
const money = (cents) => {
  try { if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents); } catch {}
  return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currencyISO });
};
const imgTag = (src, alt = '', display = 48) => {
  if (!src) return '';
  const sep = src.includes('?') ? '&' : '?';
  const w1 = display;         // 1x
  const w2 = display * 2;     // 2x
  const w3 = display * 3;     // 3x
  // carré centré pour éviter les déformations
  const src1x = `${src}${sep}width=${w1}&height=${w1}&crop=center`;
  const src2x = `${src}${sep}width=${w2}&height=${w2}&crop=center`;
  const src3x = `${src}${sep}width=${w3}&height=${w3}&crop=center`;

  return `
    <img
      src="${src2x}"
      srcset="${src1x} 1x, ${src2x} 2x, ${src3x} 3x"
      width="${display}" height="${display}"
      alt="${escapeAttr(alt)}"
      loading="lazy" decoding="async"
      style="inline-size:${display}px; block-size:${display}px; object-fit:cover; border-radius:.25rem;"
    >`;
};
document.querySelectorAll('.predictive-search-form').forEach(initPredictiveSearch);

function initPredictiveSearch(form) {
  // Racines & éléments
  const root   = form.closest('.predictive-search-form')?.parentElement || form.parentElement || form;
  const input  = form.querySelector('.search-input');
  const reset  = form.querySelector('.predictive-search__reset-button');
  const viewAll= root.querySelector('.predictive-search__search-button');
  // IMPORTANT: on cible les deux conteneurs distincts
  const empty  = root.querySelector('[data-ps-empty]');
  const box    = root.querySelector('[data-ps-results]'); // contiendra notre HTML de résultats

  if (!input || !empty || !box) return;

  // État
  let items = [];
  let index = -1;
  let abortCtrl = null;

  // Helpers affichage
  const show = (el) => el && el.removeAttribute('hidden');
  const hide = (el) => el && el.setAttribute('hidden', '');

  const openResults = () => { show(box); input.setAttribute('aria-expanded', 'true'); };
  const closeAll    = () => { input.setAttribute('aria-expanded', 'false'); index = -1; hide(box); hide(empty); };

  const showEmptyIfFocusedAndEmpty = () => {
    const isFocused = document.activeElement === input;
    const isEmpty   = !input.value.trim();
    if (isFocused && isEmpty) { show(empty); hide(box); }
    else { hide(empty); }
  };

  const setActive = (next) => {
    if (!items.length) return;
    items.forEach(el => el.setAttribute('aria-selected', 'false'));
    index = (next + items.length) % items.length;
    const el = items[index];
    el.setAttribute('aria-selected', 'true');
    el.scrollIntoView({ block: 'nearest' });
  };

  // Rendu "récentes" (dans le conteneur résultats pour garder navigation clavier)
  const renderRecent = () => {
    const recent = getRecent();
    if (!recent.length) {
      // Pas de récentes : laisse l’empty-state gérer l’affichage si input vide
      box.innerHTML = '';
      items = [];
      showEmptyIfFocusedAndEmpty();
      return;
    }
    box.innerHTML = `
      <div class="ps-section" aria-label="Recherches récentes">
        <div class="ps-title" style="font-size:.75rem;opacity:.7;padding:.5rem 1rem;">Recherches récentes</div>
        <ul class="ps-list" role="listbox" id="predictive-search-results" style="list-style:none;margin:0;padding:.25rem;">
          ${recent.map(q => `
            <li class="ps-item" role="option" aria-selected="false"
                data-type="query" data-query="${escapeAttr(q)}"
                data-url="${escapeAttr((window.Theme?.routes?.search_url || '/search') + '?q=' + encodeURIComponent(q))}"
                style="display:flex;gap:.5rem;align-items:center;padding:.5rem 1rem;cursor:pointer;border-radius:.4rem;">
              <span class="ps-item__meta">${escapeHTML(q)}</span>
            </li>`).join('')}
        </ul>
      </div>`;
    wireItems();
    hide(empty);
    openResults();
  };

  // Rendu des résultats (produits + suggestions)
  const renderResults = (data, q) => {
    const res = data?.resources?.results || {};
    const queries  = res.queries || [];
    const products = res.products || [];

    const queriesHtml = (() => {
      const list = [{ query: q, url: (window.Theme?.routes?.search_url || '/search') + '?q=' + encodeURIComponent(q) }, ...queries].slice(0, 8);
      if (!list.length) return '';
      return `
        <div class="ps-section" aria-label="Suggestions">
          <div class="ps-title" style="font-size:.75rem;opacity:.7;padding:.5rem 1rem;">Suggestions</div>
          <ul class="ps-list" role="listbox" style="list-style:none;margin:0;padding:.25rem;">
            ${list.map(s => `
              <li class="ps-item" role="option" aria-selected="false"
                  data-type="query"
                  data-query="${escapeAttr(s.query || s.title || '')}"
                  data-url="${escapeAttr(s.url || (window.Theme?.routes?.search_url || '/search') + '?q=' + encodeURIComponent(s.query || ''))}"
                  style="display:flex;gap:.5rem;align-items:center;padding:.5rem 1rem;cursor:pointer;border-radius:.4rem;">
                <span class="ps-item__meta">${escapeHTML(s.query || s.title || '')}</span>
              </li>`).join('')}
          </ul>
        </div>`;
    })();

    const productsHtml = (() => {
      if (!products.length) return '';
      const list = products.slice(0, 8).map(p => {
        const url   = p.url;
        const title = p.title;
        const img   = p.image || (p.featured_image && p.featured_image.url) || '';
        const price = typeof p.price === 'number' ? money(p.price) : '';
        return `
          <li class="ps-item" role="option" aria-selected="false"
              data-type="product" data-url="${escapeAttr(url)}"
              style="display:flex;gap:.5rem;align-items:center;padding:.5rem 1rem;cursor:pointer;border-radius:.4rem;">
            ${imgTag(img, title, 100)}
            <div class="ps-item__meta">
              <div>${escapeHTML(title)}</div>
              ${price ? `<small>${price}</small>` : ''}
            </div>
          </li>`;
      }).join('');
      return `
        <div class="ps-section" aria-label="Produits">
          <div class="ps-title" style="font-size:.75rem;opacity:.7;padding:.5rem 1rem;">Produits</div>
          <ul class="ps-list" role="listbox" style="list-style:none;margin:0;padding:.25rem;">
            ${list}
          </ul>
        </div>`;
    })();

    if (!queriesHtml && !productsHtml) {
      box.innerHTML = `<div class="ps-empty" role="status" style="padding:1rem;opacity:.7;">Aucun résultat pour “${escapeHTML(q)}”</div>`;
      items = [];
      hide(empty);
      openResults();
      return;
    }

    box.innerHTML = `${productsHtml}${queriesHtml}`;
    wireItems();
    hide(empty);
    openResults();
  };

  // Câblage des items
  const wireItems = () => {
    items = Array.from(box.querySelectorAll('.ps-item'));
    items.forEach(el => {
      el.addEventListener('mouseenter', () => {
        items.forEach(i => i.setAttribute('aria-selected', 'false'));
        el.setAttribute('aria-selected', 'true');
        index = items.indexOf(el);
      });
      el.addEventListener('click', () => {
        const type = el.getAttribute('data-type');
        if (type === 'query') {
          const q = el.getAttribute('data-query') || '';
          if (q) saveRecent(q);
        } else {
          const q = input.value.trim();
          if (q) saveRecent(q);
        }
        const url = el.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });
  };

  // Fetch Predictive
  const fetchResults = async (q) => {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    const base = window.Theme?.routes?.predictive_search_url || '/search/suggest.json';
    const url = new URL(base, window.location.origin);
    url.searchParams.set('q', q);
    url.searchParams.set('resources[type]', 'product,collection,article,page');
    url.searchParams.set('resources[limit]', '8');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title');

    try {
      const resp = await fetch(url.toString(), { signal: abortCtrl.signal });
      if (!resp.ok) throw new Error('Network error');
      const data = await resp.json();
      renderResults(data, q);
    } catch (e) {
      if (e.name === 'AbortError') return;
      // fallback minimal
      box.innerHTML = '';
      items = [];
      showEmptyIfFocusedAndEmpty();
    }
  };

  // Events
  const onInput = debounce(() => {
    const q = input.value.trim();
    toggleReset(q.length > 0);
    if (!q) { box.innerHTML = ''; items = []; showEmptyIfFocusedAndEmpty(); return; }
    fetchResults(q);
  });

  const onKeyDown = (ev) => {
    if (ev.key === 'Escape') { closeAll(); input.blur(); return; }
    if (box.hasAttribute('hidden') || !items.length) return;

    if (ev.key === 'ArrowDown') { ev.preventDefault(); setActive(index + 1); }
    else if (ev.key === 'ArrowUp') { ev.preventDefault(); setActive(index - 1); }
    else if (ev.key === 'Enter') {
      const active = items[index];
      if (active) {
        ev.preventDefault();
        const type = active.getAttribute('data-type');
        if (type === 'query') {
          const q = active.getAttribute('data-query') || input.value.trim();
          if (q) saveRecent(q);
        } else {
          const q = input.value.trim();
          if (q) saveRecent(q);
        }
        const url = active.getAttribute('data-url');
        if (url) window.location.href = url;
      } else {
        // submit normal
        saveRecent(input.value.trim());
      }
    }
  };

  const onFocus = () => {
    const q = input.value.trim();
    if (q) { fetchResults(q); }
    else { // input vide -> empty-state visible
      box.innerHTML = '';
      items = [];
      showEmptyIfFocusedAndEmpty();
    }
  };

  const onBlur = () => {
    // On laisse l’empty-state masqué si on sort du champ
    hide(empty);
  };

  const onSubmit = () => {
    const q = input.value.trim(); if (q) saveRecent(q);
  };

  const toggleReset = (show) => { if (reset) reset.hidden = !show; };
  const doReset = () => {
    input.value = '';
    toggleReset(false);
    box.innerHTML = '';
    items = [];
    showEmptyIfFocusedAndEmpty();
    input.focus();
  };

  input.addEventListener('input', onInput);
  input.addEventListener('keydown', onKeyDown);
  input.addEventListener('focus', onFocus);
  input.addEventListener('blur', onBlur);
  form.addEventListener('submit', onSubmit);
  reset && reset.addEventListener('click', doReset);
  viewAll && viewAll.addEventListener('click', (e) => {
    e.preventDefault();
    const q = input.value.trim();
    const url = new URL(window.Theme?.routes?.search_url || '/search', location.origin);
    if (q) url.searchParams.set('q', q);
    if (q) saveRecent(q);
    window.location.href = url.toString();
  });

  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) closeAll();
  }, { capture: true });

  // État initial : pas de fetch, pas d’affichage
  toggleReset(!!input.value.trim());
  closeAll(); // cache empty + results
}

// helpers
function escapeHTML(str){ return String(str).replace(/[&<>"]/g, s => ({'&':'&amp;','<':'&lt;','>':'&gt;'}[s])); }
function escapeAttr(str){ return escapeHTML(str).replace(/"/g, '&quot;'); }